var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('div',{class:[
			'fas-loading-indicator',
			{ 'fas-loading-indicator__full_page': !_vm.component },
			`fas-loading-indicator-color--${_vm.loaderBcgColor}`
		]},[_c('div',{class:[
				'fas-loading-indicator__loading-container',
				{ 'has-text': _vm.message.length > 0 }
			]},[_c('div',{staticClass:"loading-animation",attrs:{"role":"img","aria-label":"Loading"}},[_c('div',{class:[
						'fas-loader',
						`fas-loader__type--${_vm.loaderType}`,
						`fas-loader__color--${_vm.colorStyle}`
					]},[(_vm.loaderType === 'spinner')?_c('SpinnerSVG',{attrs:{"loading":true,"spinnerStrokeWidth":_vm.spinnerStrokeWidth,"colorTheme":_vm.colorStyle}}):(_vm.loaderType === 'legacy')?_c('div',[_c('div',{staticClass:"legacy-animation",attrs:{"role":"image","aria-label":"Loading"}},[_c('span',{staticClass:"bar"}),_vm._v(" "),_c('span',{staticClass:"bar"}),_vm._v(" "),_c('span',{staticClass:"bar"}),_vm._v(" "),_c('span',{staticClass:"bar"}),_vm._v(" "),_c('span',{staticClass:"bar"}),_vm._v(" "),_c('span',{staticClass:"ball"})])]):_vm._e()],1)]),_vm._v(" "),(_vm.message.length > 0)?_c('div',{class:[
					'fas-loading-indicator__loading-text',
					`fas-loading-indicator__loading-text__style--${_vm.loaderTextStyle}`,
					`fas-loading-indicator__loading-text__color--${_vm.loaderTextColor}`
				]},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})]):_vm._e()])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }